import Cookies from 'js-cookie'

const expiration = 1 // days

var cookieNewsletter = Cookies.get('newsletter-popup');
var cookieCookiesMessage = Cookies.get('showCookiesMsg');

if (!cookieNewsletter && cookieCookiesMessage) {
    setTimeout(function () {
        $.fancybox.open({
            src: '#newsletter',
            type: 'inline',
            opts: {
                clickSlide: false,
                animationEffect: "zoom-in-out",
                animationDuration: 500,
                btnTpl: {
                    smallBtn: `
                    <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                        <i class="icon-close"></i>
                    </button>
                    `,
                },
                // beforeShow: function (instance, current) {
                //     $('.lazy-now').Lazy({
                //         afterLoad: function (element) {
                //             element.find(".loader").fadeOut();
                //         },
                //     });
                // },
                afterClose: function () {
                    Cookies.set('newsletter-popup', 'shown', {
                        expires: expiration
                    });

                    // $scope.frm.gender = "";
                    // $scope.frm.name = "";
                    // $scope.frm.email = "";
                    // $scope.frm.phone = "";

                    // $scope.newsletter.sending = false;
                    // $scope.newsletter.sent = false;
                }
            },
        });
    }, 5000);
}